import z from 'zod';

const createRelayStatusFieldSchema = <T extends z.ZodTypeAny>(
  valueSchema: T,
) => {
  return z.object({
    timestamp: z.number(),
    value: valueSchema,
  });
};

export const RelayStatusFieldSchema = createRelayStatusFieldSchema(z.any());

export const NotificationSchema = z.object({
  id: z.number(),
  timestamp: z.number(),
  channel: z.string(),
  title: z.string().optional(),
  content: z.string().optional(),
});
export const RelayStatusSchema = z.object({
  timestamp: z.number().optional(),

  // PhoneStatusStream
  batteryIsCharging: createRelayStatusFieldSchema(z.boolean()).optional(),
  batteryPercent: createRelayStatusFieldSchema(z.number()).optional(),
  bluetoothGattConnectedDevices: createRelayStatusFieldSchema(
    z.array(z.string()),
  ).optional(),
  bluetoothIsOn: createRelayStatusFieldSchema(z.boolean()).optional(),
  ringerIsEnabled: createRelayStatusFieldSchema(z.boolean()).optional(),
  phoneNumber: createRelayStatusFieldSchema(z.string()).optional(),
  mbsAppVersion: createRelayStatusFieldSchema(z.string()).optional(),
  relayId: createRelayStatusFieldSchema(z.string()).optional(),
  relayAppVersion: createRelayStatusFieldSchema(z.string()).optional(),
  availableStorageMB: createRelayStatusFieldSchema(z.number()).optional(),
  androidSoftwareVersion: createRelayStatusFieldSchema(z.string()).optional(),
  uptimeMillis: createRelayStatusFieldSchema(z.number()).optional(),

  // MBSAppStatusStream
  mbsAppStatus: createRelayStatusFieldSchema(z.string()).optional(),

  // NetworkStatusStream
  cellularNetworkType: createRelayStatusFieldSchema(z.string()).optional(),
  cellularNetworkLevel: createRelayStatusFieldSchema(z.number()).optional(),
  activeNotifications: createRelayStatusFieldSchema(
    z.array(NotificationSchema),
  ).optional(),
});
export const RelayStatusGetAllResponseSchema = z.object({
  relayStatuses: RelayStatusSchema.array(),
});

export const RelayStatusRequestSchema = z.object({
  deviceIds: z.string(),
});
